import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

interface IconProps {
  size?: number
  color?: string
}

const ExpiredFilled = ({ size = 16, color = '#DA5847' }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 16 16"
    fill="none"
  >
    <Path
      d="M12.7334 2.425H12.0834V1.25C12.0834 0.833333 11.75 0.5 11.3334 0.5C10.9167 0.5 10.5834 0.833333 10.5834 1.25V2.425H5.41669V1.25C5.41669 0.833333 5.08336 0.5 4.66669 0.5C4.25002 0.5 3.91669 0.833333 3.91669 1.25V2.425H3.29169C1.76669 2.425 0.525024 3.66667 0.525024 5.19167V5.475H15.5084V5.19167C15.5084 3.66667 14.2667 2.425 12.7417 2.425H12.7334Z"
      fill={color}
    />
    <Path
      d="M0.516724 12.7083C0.516724 14.2333 1.75839 15.475 3.28339 15.475H12.7251C14.2501 15.475 15.4917 14.2333 15.4917 12.7083V6.79999H0.516724V12.7083ZM8.70839 8.39165L8.55839 11.6417H7.43339L7.28339 8.39165H8.70839ZM7.99172 12.1583C8.40839 12.1583 8.72506 12.475 8.72506 12.8917C8.72506 13.3083 8.40839 13.625 7.99172 13.625C7.57506 13.625 7.25839 13.3083 7.25839 12.8917C7.25839 12.475 7.57506 12.1583 7.99172 12.1583Z"
      fill={color}
    />
  </Svg>
)

export default ExpiredFilled
